import { AxiosRequestConfig } from "axios/index";
import { appendQueryToUrl } from "@/utils";
import {
  http,
  getRequestSubmitEndpoint,
  SubmitRequestsPayloadPart,
  SubmitRequestsResponse,
} from "@/services";

export const submitRequest = (
  {
    email,
    request,
  }: {
    email: string;
    request: SubmitRequestsPayloadPart;
  },
  config?: AxiosRequestConfig,
) => {
  const url = appendQueryToUrl(getRequestSubmitEndpoint, { email });

  return http.post<SubmitRequestsResponse>(url, { ...request }, config);
};
